module.exports = __webpack_public_path__ + "static/media/tasks.c099e9a3.svg";


//////////////////
// WEBPACK FOOTER
// ../images/tasks.svg
// module id = 663
// module chunks = 0